import type { ReactNode } from 'react'
import { cn } from '@/shared/lib'

type LinkButtonProps = {
  children: ReactNode
  onClick: () => void
  isDisabled?: boolean
  className?: string
}

/**
 * Текстовая кнопка `.link` — 17px `tg-link`, тап-зона 44px: второстепенное
 * действие отказного экрана, «Пропустить», «Изменить».
 */
export const LinkButton = ({ children, onClick, isDisabled = false, className }: LinkButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={isDisabled}
    className={cn(
      'min-h-11 border-0 bg-transparent px-2 text-cell-title text-tg-link disabled:opacity-45',
      className,
    )}
  >
    {children}
  </button>
)
